import styled from 'styled-components'

import { offWhite, darkBlue } from 'styles/settings/colors'
import { txt16OpenSans } from '../../../styles/settings/types'
import rem from 'styles/tools/rem'
import media from '../../../styles/tools/media'

export const Separator = styled.hr`
  background-color: ${offWhite};
  border: 0;
  height: ${rem('1px')};
  margin: ${rem('20px')} 0;
`

export const WarningContent = styled.div`
  color: ${darkBlue};
  font-family: OpenSans;
  font-size: ${rem('14px')};
`

export const WarningSubtitle = styled.div`
  margin-bottom: ${rem('4px')};
  font-size: ${rem('16px')};
  font-weight: 600;
`

export const WarningDisclaimer = styled.div`
  margin-top: ${rem('24px')};
  margin-bottom: ${rem('36px')};
  font-size: ${rem('12px')};
  font-weight: 600;
`
export const LinkBanner = styled.a`
  ${txt16OpenSans} color: ${darkBlue};
  font-weight: normal;
  letter-spacing: $normal;
  line-height: 1.5;
  white-space: normal;
  cursor: pointer;
  text-decoration: underline;
`

export const ModalIllustration = styled.img`
  display: block;
  margin: 0 auto;
  width: 32%;
  display: block;
  max-height: 88%;
  position: absolute;
  right: ${rem('50px')};
  top: 51%;
  transform: translateY(-50%) translateX(0%);
`

export const ModalTitle = styled.h1`
  color: ${offWhite};
  font-family: 'Galano';
  font-size: ${rem('24px')};
  font-weight: 600;
  line-height: 1.17;
  margin: 0;
  text-align: center;

  ${media.large`
  font-size: ${props => (props.compact ? rem('24px') : rem('26px'))};
    line-height: 1.04;
    max-width: ${rem('215px')};
    text-align: left;
  `};

  svg {
    margin-left: -5px;
    g {
      fill: #fff !important;
    }
  }
`

export const ModalDescription = styled.h1`
  ${txt16OpenSans} color: ${darkBlue};
  font-weight: normal;
  letter-spacing: $normal;
  line-height: 1.5;
  margin-bottom: ${rem('20px')};
  white-space: normal;
  width: 100%;
  max-width: ${rem('320px')};

  ${media.large`
    text-align: left;
  `};
`

export const WrapperModal = styled.div`
  div > div {
    min-height: 168px !important;
    margin-top: -14px;
    margin-bottom: -11px;
  }

  div > div > div {
    overflow-x: hidden;
  }
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardResume/styles.js